<template>
    <div v-if="images"
        class="owl-carousel"
        :id="['owl-' + unitid]">
        <div v-for="img in images"
            class="item">

            <img-fallback :img="img.id"
                mode="img"
                img-format="m"
                vo-msg:placeholder="no.pic.placeholder"></img-fallback>


        </div>
    </div>
    <div v-else>
        <img-fallback mode="img"
            vo-msg:placeholder="no.pic.placeholder"></img-fallback>
    </div>
</template>

<script>
    import V from 'voUtils/V.js'



    export default {
    	voVueComponent: 'last-viewed-img-carousel',
    	props: {
    		images: Array,
    		default: () => [{
    			id: -1,
    			width: 450,
    			height: 300,
    			name: '//via.placeholder.com/450x300&text=No%20Image'
    		}],
    		unitid: Number,
    		unitpath: String

    	},

    	mounted: function() {
    		$("#owl-" + this.unitid).owlCarousel({
    			items: 1,
    			loop: true,
    			center: false,
    			autoplay: false,
    			smartSpeed: 3000,
    			dots: true,
    			nav: true
    		});
    	},

    	methods: {
    		getTarget: function() {
    			if (window.screen.width < 768) {
    				//probably phone?
    				return '_self';
    			} else {
    				return 'unit_' + id;
    			}
    		},
    		getUnitPath: function() {
    			return
    		}
    	}

    };
</script>